<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="container">
        <div class="row align-start">

          <!-- 1. Kolon: Logo + Tanıtım -->
          <div class="col-md-2 footer-widget">
            <img src="/images/logo/intek-electronic-logo.png" alt="İNTEK ELECTRONIC Logo" class="footer-logo" />
            
          </div>
          <div class="col-md-4 footer-widget">
           <h3 class="widget-title">İntek Bilişim Teknolojileri</h3>
            <p>
              İntek Bilişim Teknolojileri, Gebze / Kocaeli merkezli bir teknoloji firmasıdır.
              Elektronik kontrol kart tasarımı ve kumanda kartları konusunda uzmanlaşmıştır.
            </p>
            <p>
              <router-link to="/blog" class="footer-blog">Blog: Elektronik Kart Tasarımı Nedir?</router-link>
            </p>
          </div>
          <!-- 2. Kolon: Site Bağlantıları -->
          <div class="col-md-3 footer-widget">
            <h3 class="widget-title">Bağlantılar</h3>
            <ul class="list-arrow">
              <li><router-link to="/">Anasayfa</router-link></li>
              <li><router-link to="/about">Hakkımızda</router-link></li>
              <li><router-link to="/services">Hizmetlerimiz</router-link></li>
              <li><router-link to="/contact">İletişim</router-link></li>
            </ul>
          </div>

          <!-- 3. Kolon: Yasal Linkler -->
          <!-- <div class="col-md-3 footer-widget">
            <h3 class="widget-title">Yasal Bilgiler</h3>
            <ul class="list-arrow">
              <li><router-link to="/kvkk">KVKK Aydınlatma Metni</router-link></li>
              <li><router-link to="/cerez-politikasi">Çerez Politikası</router-link></li>
              <li><router-link to="/kullanim-kosullari">Kullanım Koşulları</router-link></li>
            </ul>
          </div> -->

          <!-- 4. Kolon: Sosyal Medya ve İletişim -->
          <div class="col-md-3 footer-widget">
            <div class="footer-contact-block">
              <div class="footer-social">
                <a href="https://www.linkedin.com/company/intek-bilisim-teknoloji/" target="_blank" class="social-icon" aria-label="LinkedIn">
                  <font-awesome-icon :icon="['fab','linkedin-in']" />
                </a>
                <a href="https://www.instagram.com/intekteknoloji/" target="_blank" class="social-icon" aria-label="Instagram">
                  <font-awesome-icon :icon="['fab','instagram']" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61569722617183" target="_blank" class="social-icon" aria-label="Facebook">
                  <font-awesome-icon :icon="['fab','facebook']" />
                </a>
              </div>
              <div class="footer-contact">
                <p><strong>Tel:</strong> 0555 887 1241</p>
                <p><strong>Email:</strong> <a href="mailto:info@intekbilisim.com.tr">info@intekbilisim.com.tr</a></p>
                <p><strong>Adres:</strong><br/> Muallimköy Mh. Deniz Cd.<br/> Bilişim Vadisi 2B Blok D:110</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
 <div class="footer-links">
      <div class="container text-center">
        <router-link to="/kvkk">KVKK Aydınlatma Metni</router-link>
        <router-link to="/cerez-politikasi">Çerez Politikası</router-link>
        <router-link to="/kullanim-kosullari">Kullanım Koşulları</router-link>
      </div>
    </div>
     <div class="footer-bottom ">
      <div class="container">
      <p>© 2024 İntek Bilişim Teknolojileri. Tüm hakları saklıdır.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  font-family: Arial, sans-serif;
  color: #333;
}
.footer-main {
  background: #f9f9f9;
  padding: 3rem 0;
}
.footer-bottom {
  background: #eaeaea;
  padding: 1rem 0;
  color: #666;
  height: 100px;
  display: flex;
  align-items: center;        /* Dikeyde ortalama */
}

.footer-bottom .container {
  width: auto;
  margin-left: 50px;          /* Soldan boşluk */
  text-align: left;           /* Yazıyı sola hizalama */
}
.footer-bottom p {
  margin: 0;
  font-size: 0.9rem;
}
.footer-links {
  background: #f9f9f9;
  text-align: center;
  padding: 1rem 0;
}
.footer-links a {
  margin: 0 1rem;
  font-size: 0.85rem;
  color: #333;
  text-decoration: none;
}
.footer-links a:hover {
  text-decoration: underline;
}

.footer-widget {
  margin-bottom: 2rem;
}
.logo-only {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-logo {
  max-width: 120px;
  height: auto;
}

.widget-title {
  font-size: 1.1rem;
  color: #0052c9;
  margin-bottom: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  padding-left: 15px;
  border-left: 3px solid gray;
  letter-spacing: 1px;
}

.list-arrow {
  list-style: none;
  padding: 0;
  margin: 0;
}
.list-arrow li {
  margin-bottom: 0.5rem;
}
.list-arrow li a {
  color: #555;
  text-decoration: none;
}
.list-arrow li a:hover {
  text-decoration: underline;
}
.list-arrow li::before {
  content: none !important;
  display: none !important;
}

.footer-contact p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}
.footer-contact a {
  color: inherit;
  text-decoration: none;
}
.footer-contact a:hover {
  text-decoration: underline;
}

.footer-social {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #555555;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.2rem;
  transition: background 0.3s, color 0.3s;
}
.social-icon:hover {
  background: gray;
  color: #ffffff;
}

@media (max-width: 767px) {
  .footer-widget {
    margin-bottom: 1.5rem;
  }
  .footer-contact-block {
    align-items: flex-start;
  }
  .footer-links a {
    display: block;
    margin: 0.5rem 0;
  }
}
</style>
